import { EntityApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";

export const deleteEntityApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${EntityApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
